import React from "react";
import PropTypes from "prop-types";

import "./ProcessSteps.scss";
import "../HistoryTeaser/HistoryTeaser.scss";
import Container from "../share/Container/Container";
import TextBox from "../share/TextBox/TextBox";
import PreviewCompatibleImage from "../share/Image/PreviewCompatibleImage";
import useBreakpoint from "../../hooks/useBreakpoint";

const PHASES = [
  { id: "planung",  label: "Planung",  match: /^[12]\./  },
  { id: "bauphase", label: "Bauphase", match: /^3/       },
  { id: "abnahme",  label: "Abnahme",  match: /^4\./     },
];

function groupByPhase(steps) {
  const groups = PHASES.map(p => ({ ...p, steps: [] }));
  steps.forEach(step => {
    const matched = groups.find(g => g.match.test(step.text || ""));
    if (matched) matched.steps.push(step);
  });
  return groups.filter(g => g.steps.length > 0);
}

const ProcessSteps = ({ steps }) => {
  const BreakpointM = useBreakpoint("m");
  const variant = BreakpointM ? "full-width" : ["no-padding", "no-top", "no-bottom"];

  if (!steps) return null;

  const phases = groupByPhase(steps);

  return (
    <div className="ProcessSteps">
      {phases.map((phase, phaseIndex) => (
        <div key={phase.id} className={`ProcessSteps__phase ProcessSteps__phase--${phase.id}`}>
          <Container variant="no-top">
            <div className="ProcessSteps__phaseHeader">
              <span className="ProcessSteps__phaseNumber">0{phaseIndex + 1}</span>
              <h3 className="ProcessSteps__phaseTitle">{phase.label}</h3>
            </div>
          </Container>

          {phase.id === "bauphase" ? (
            <Container variant="no-top">
              <div className="ProcessSteps__bauphaseGrid">
                {phase.steps.map((step, index) => (
                  <div
                    key={index}
                    className={`ProcessSteps__bauphaseCard ${!step.image ? "ProcessSteps__bauphaseCard--text" : ""}`}
                  >
                    {step.image && (
                      <div className="ProcessSteps__bauphaseImage">
                        <PreviewCompatibleImage
                          imageInfo={{ image: step.image, alt: step.text }}
                        />
                      </div>
                    )}
                    <div className="ProcessSteps__bauphaseContent">
                      <h4 className="ProcessSteps__bauphaseTitle">{step.text}</h4>
                      <p className="ProcessSteps__bauphaseText">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Container>
          ) : (
            <div className="ProcessSteps__teasers">
              {phase.steps.map((element, index) => (
                <div className={`ProcessSteps__teaser HistoryTeaser ${!element.image ? "ProcessSteps__teaser--noImage" : ""}`} key={index}>
                  <Container variant={variant}>
                    <div className={`HistoryTeaser__wrapper ${index % 2 !== 0 ? "HistoryTeaser__wrapper--reverse" : ""} ${!element.image ? "HistoryTeaser__wrapper--noImage" : ""}`}>
                      <div className="HistoryTeaser__content">
                        <TextBox title={element.text} text={element.description} isRichText={true} />
                      </div>
                      {element.image && (
                        <div className="HistoryTeaser__image">
                          <PreviewCompatibleImage
                            imageInfo={{ image: element.image, alt: element.text }}
                          />
                        </div>
                      )}
                    </div>
                  </Container>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

ProcessSteps.propTypes = {
  steps: PropTypes.array,
};

export default ProcessSteps;
